import React from "react";
import _ from "lodash";

import { TQuestionOption } from "../../types";
import { useField } from "formik";

import SelectionCard from "./SelectionCard";

type TCheckboxProps = {
  name: string;
  option: TQuestionOption;
  error?: boolean;
};

const Checkbox: React.FC<TCheckboxProps> = ({ name, option, error = false }) => {
  const [field] = useField(name);
  const id = _.kebabCase(`${name}-${option.value}`);
  const [isFocused, setFocus] = React.useState(false);

  const isChecked = () => {
    if (!field.value) {
      return false;
    }
    return field.value.includes(option.value);
  };

  return (
    <>
      <input
        style={{ opacity: 0, position: "absolute" }}
        type="checkbox"
        id={id}
        value={option.value}
        name={name}
        onChange={field.onChange}
        onBlur={(e) => {
          setFocus(false);
          field.onBlur(e);
        }}
        onFocus={() => {
          setFocus(true);
        }}
        checked={isChecked()}
      />
      <SelectionCard
        style={
          isFocused
            ? { outline: "1px solid", outlineColor: "#1e90fc" }
            : error
            ? { outline: "1px solid", outlineColor: "#D82727" }
            : {}
        }
        checked={isChecked()}
        fieldId={id}
        text={option.label}
        secondaryText={option.note}
        variant="square"
      />
    </>
  );
};

export default Checkbox;
